import {NgModule} from '@angular/core';
import {IsoDatePipe} from './shared/pipes/isoDate.pipe';
import {IsoDateTimePipe} from './shared/pipes/isoDateTime.pipe';

@NgModule({
  declarations: [
    IsoDatePipe,
    IsoDateTimePipe
  ],
  exports: [
    IsoDatePipe,
    IsoDateTimePipe
  ],
  imports: [],
  providers: []
})
export class CommonModule {
}
